<template>
  <div class="ma-4">
    <v-row class="justify-center">
      <v-col class="col-12">
        <v-card outlined>
          <v-card-title>Events</v-card-title>

          <v-card-text>
            <capacity-calendar
              v-if="eventProducts"
              :products="eventProducts.events"
              hide-select-periode
              @date-changed="dateChanged"
              @click:day="createEvent"
              @capacityOverridden="loadCalendarData()"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CapacityCalendar from '../../capacityCalendar/CapacityCalendar'
import EventProducts from '../../../classes-shared/events/EventProducts'
import moment from 'moment'

export default {
  name: 'EventsOverview',
  components: { CapacityCalendar },

  data() {
    return {
      eventProducts: null,

      // for the capacity calendar
      dateRange: {
        from: moment().startOf('month'),
        to: moment().startOf('month').add(1, 'month'),
      },
    }
  },

  mounted() {
    // load events
    this.loadCalendarData()
  },

  methods: {
    // starting point to load all data which the calendar needs
    async loadCalendarData() {
      this.eventProducts = new EventProducts()
      await this.eventProducts.loadEvents(
        null,
        this.dateRange.from,
        this.dateRange.to
      )
      this.eventProducts.loadCapacities(this.dateRange.from, this.dateRange.to)
    },

    createEvent(day) {
      // create new event
      this.$router.push({ name: 'createEvent', params: { date: day.date } })
    },

    dateChanged(dateRange) {
      this.dateRange = dateRange
      this.loadCalendarData()
    },
  },
}
</script>
